import type { LiveMessage } from '@/common/bot/flow-frameworks/messages';
import { getCreatedAtTimestampMs } from '@/common/getCreatedAtTimestampMs';
import { devLog } from '@/common/debug';

export type LiveChatQueueSendTarget = {
  sendMessage: (message: string, options: Record<string, unknown>) => Promise<unknown>;
};

/**
 * Flushes live-chat queue messages to the agent in order, preserving per-line `createdAt`
 * (see Chatroom.sendMessagesToAgentChat).
 */
export async function sendQueuedLiveChatMessages(
  selections: ReadonlyArray<LiveMessage>,
  chat: LiveChatQueueSendTarget
): Promise<void> {
  for (const { message, meta, createdAt } of selections) {
    const createdAtMs = getCreatedAtTimestampMs(createdAt);
    if (createdAtMs === null) {
      devLog.debug('[WIDGET_CONVERSATION] Live chat queue message has no createdAt', { message });
    }
    await chat.sendMessage(message, {
      userSelection: true,
      ...meta,
      ...(createdAtMs !== null ? { createdAt: createdAtMs } : {}),
    });
  }
}
